import { WELCOME } from "@/content/ministry";
import { useChat } from "@/state/ChatProvider";
import { Button } from "@/components/ui/Button";
import { Container } from "@/components/ui/Primitives";
import { SplitText, Reveal } from "@/components/motion/Reveal";

export function FinalCta() {
  const { openWith } = useChat();
  return (
    <section className="final-cta" aria-label="Plan your visit">
      <div className="final-cta__flame" aria-hidden />
      <Container>
        <SplitText as="p" text={"Just one visit will\nchange your life forever."} className="final-cta__title" step={60} />
        <Reveal delay={300} className="final-cta__actions">
          <Button to="/new" variant="flame" size="lg" iconRight="arrowRight">
            Plan your first visit
          </Button>
          <Button variant="ghost" size="lg" icon="sparkle" onClick={() => openWith()}>
            Ask Miracle Assembly AI
          </Button>
        </Reveal>
        <p className="sr-only">{WELCOME.promise}</p>
      </Container>
    </section>
  );
}
